import {
  FETCH_NODE_AI_HISTORY_START,
  FETCH_NODE_AI_HISTORY_SUCCESS,
  FETCH_NODE_AI_HISTORY_FAIL,
  FETCH_NODE_AI_HISTORY_PREPEND,
} from './action';

const emptyNode = {
  items: [],
  nextCursor: null,
  isLoading: false,
  isInitial: false,
  err: null,
};

const initialState = {
  byNode: {},
};

const aiHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_NODE_AI_HISTORY_START: {
    const prev = state.byNode[action.nodeId] || emptyNode;
    return {
      ...state,
      byNode: {
        ...state.byNode,
        [action.nodeId]: { ...prev, isLoading: true, err: null },
      },
    };
  }
  case FETCH_NODE_AI_HISTORY_SUCCESS: {
    const prev = state.byNode[action.nodeId] || emptyNode;
    const page = action.payload?.items || [];
    const items = action.append ? [...prev.items, ...page] : page;
    return {
      ...state,
      byNode: {
        ...state.byNode,
        [action.nodeId]: {
          items,
          nextCursor: action.payload?.nextCursor ?? null,
          isLoading: false,
          isInitial: true,
          err: null,
        },
      },
    };
  }
  case FETCH_NODE_AI_HISTORY_PREPEND: {
    const prev = state.byNode[action.nodeId] || emptyNode;
    const existingIds = new Set(prev.items.map((item) => item.id));
    const fresh = (action.items || []).filter((item) => !existingIds.has(item.id));
    return {
      ...state,
      byNode: {
        ...state.byNode,
        [action.nodeId]: {
          ...prev,
          items: [...fresh, ...prev.items],
          isLoading: false,
          isInitial: true,
          err: null,
        },
      },
    };
  }
  case FETCH_NODE_AI_HISTORY_FAIL: {
    const prev = state.byNode[action.nodeId] || emptyNode;
    return {
      ...state,
      byNode: {
        ...state.byNode,
        [action.nodeId]: {
          ...prev,
          isLoading: false,
          err: action.error?.message || true,
        },
      },
    };
  }
  default:
    return state;
  }
};

export default aiHistoryReducer;
